import {AmountControlInterface} from '../../interfaces';

import {BaseControl} from './base-control';

export class AmountControl extends BaseControl<string> {
    public currency: string;
    public isInitialFormattingActive: boolean;
    public isPercentage: boolean;
    public fourDecimals: boolean;

    constructor(data: AmountControlInterface) {
        super(data);

        this.currency = data.currency;
        this.isInitialFormattingActive = data.isInitialFormattingActive ?? false;
        this.isPercentage = data.isPercentage ?? false;
        this.fourDecimals = data.fourDecimals ?? false;
    }
}
